import { router } from 'expo-router';
import { useCallback } from 'react';

import { queryClient } from '@fhs/client';
import {
  ILoyaltyQuestUi,
  LoyaltyQuestStatus,
  useActivateQuestMutation,
} from '@fhs-legacy/frontend/src/generated/graphql-gateway';
import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';

import { challengesUiQueryKeys } from '../queries/loyalty.queries';

export function useOnPressChallenge() {
  const loyaltyId = useAppSelector(selectors.loyalty.selectLoyaltyUserId);

  const [activateChallenge] = useActivateQuestMutation();

  return useCallback(
    async (challenge: ILoyaltyQuestUi) => {
      if (challenge.status === LoyaltyQuestStatus.NOT_ENROLLED) {
        await activateChallenge({
          variables: { questId: challenge.id, loyaltyId },
          onCompleted: () =>
            queryClient.invalidateQueries({
              queryKey: challengesUiQueryKeys.params({ loyaltyId }),
            }),
        });
        return;
      }

      router.navigate(routes.menu);
    },
    [activateChallenge, loyaltyId]
  );
}
